(function () {
  'use strict';

  var STORAGE_KEY = 'cntz_attribution_v1';
  var TTL_MS = 30 * 24 * 60 * 60 * 1000;
  var TRACKED_PARAMS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'utm_id',
    'ref'
  ];

  function trimValue(value, maxLength) {
    if (!value) return '';
    return String(value).trim().slice(0, maxLength || 180);
  }

  function externalReferrerHost() {
    if (!document.referrer) return '';
    try {
      var referrer = new URL(document.referrer);
      if (referrer.origin === window.location.origin) return '';
      return trimValue(referrer.hostname, 120);
    } catch (e) {
      return '';
    }
  }

  function readStored() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || !parsed.expires_at || Date.now() > parsed.expires_at) {
        window.localStorage.removeItem(STORAGE_KEY);
        return null;
      }
      return parsed;
    } catch (e) {
      return null;
    }
  }

  function writeStored(value) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
      return true;
    } catch (e) {
      return false;
    }
  }

  function captureCurrentTouch() {
    var params = new URLSearchParams(window.location.search);
    var captured = {};

    TRACKED_PARAMS.forEach(function (key) {
      var value = trimValue(params.get(key));
      if (value) captured[key] = value;
    });

    var referrerHost = externalReferrerHost();
    if (!Object.keys(captured).length && !referrerHost) return null;

    return {
      params: captured,
      landing_path: trimValue(window.location.pathname + window.location.search, 300),
      referrer_host: referrerHost,
      captured_at: new Date().toISOString(),
      expires_at: Date.now() + TTL_MS
    };
  }

  var currentTouch = captureCurrentTouch();
  var attribution = currentTouch || readStored();
  if (currentTouch) writeStored(currentTouch);

  function getAttribution() {
    var stored = readStored();
    if (stored) attribution = stored;
    return attribution;
  }

  function appendParam(parts, key, value) {
    if (!value) return;
    parts.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
  }

  function decorateCheckoutUrl(baseUrl) {
    var data = getAttribution();
    if (!data) return baseUrl;

    var parts = [];
    var params = data.params || {};

    TRACKED_PARAMS.forEach(function (key) {
      var value = trimValue(params[key]);
      if (!value) return;

      // Keep standard campaign parameters on the checkout URL for analytics.
      appendParam(parts, key, value);

      // Also write them as cart attributes so attribution survives into the order.
      appendParam(parts, 'attributes[cntz_' + key + ']', value);
    });

    appendParam(parts, 'attributes[cntz_landing_path]', trimValue(data.landing_path, 300));
    appendParam(parts, 'attributes[cntz_referrer_host]', trimValue(data.referrer_host, 120));

    if (!parts.length) return baseUrl;
    return baseUrl + (baseUrl.indexOf('?') === -1 ? '?' : '&') + parts.join('&');
  }

  window.CNTZAttribution = {
    get: getAttribution,
    decorateCheckoutUrl: decorateCheckoutUrl
  };
})();
